import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const WineSubscription = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

const Subscription = withAppProviders(WineSubscription)();
export default Subscription;

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-subscription");
	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<Subscription />
			</Suspense>,
			element
		);
	}
});
